<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>老客回馈</span>
                </div>
            </div>
            <el-form label-width="120px" :model="userData" ref="oldForm">
                <el-form-item label="购买渠道" prop="shop_name">
                    <span>{{ userData.shop_name }}</span>
                </el-form-item>
                <el-form-item label="订单号" v-if="userData.order_id" prop="order_id">
                    <span>{{ userData.order_id }}</span>
                </el-form-item>
                <el-form-item label="购买截图" v-if="userData.order_img_url" prop="">
                    <el-image 
                        style="width: 100px; height: 100px;"
                        fit="contain"
                        :src="userData.order_img_url" 
                        :preview-src-list="[userData.order_img_url]">
                    </el-image>
                </el-form-item>
                <el-form-item label="申请人手机号" prop="phone">
                    <el-input v-model="userData.phone"></el-input>
                </el-form-item>
                <el-form-item label="审核状态" prop="" v-if="userData.order_img_url">
                    <el-radio v-model="oldSatus" :disabled="oldIsFinish" :label="3">不通过</el-radio>
                    <el-radio v-model="oldSatus" :disabled="oldIsFinish" :label="1">通过</el-radio>
                </el-form-item>
                <el-form-item label="是否发放" prop="">
                    <el-switch
                        :disabled="oldSatus != 1"
                        v-model="oldIsFinish"
                        active-color="#13ce66"
                        inactive-color="#c0c4cc">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div class="title_box">
                <div class="title">
                    <span>分享返现</span>
                </div>
            </div>
            <el-form label-width="120px" :model="userData" ref="shareForm">
                <el-form-item label="有赞订单号" prop="new_order_id">
                    <span>{{ userData.new_order_id }}</span>
                </el-form-item>
                <el-form-item label="小红书ID" prop="xhs_account">
                    <span>{{ userData.xhs_account }}</span>
                </el-form-item>
                <el-form-item label="支付宝账号" prop="ali_pay_id">
                    <span>{{ userData.ali_pay_id }}</span>
                </el-form-item>
                <el-form-item label="上传笔记" v-if="userData.note1_url" prop="">
                    <el-image 
                        style="width: 100px; height: 100px;"
                        fit="contain"
                        z-index="1"
                        initial-index="1"
                        :src="userData.note1_url" 
                        :preview-src-list="shareUrl">
                    </el-image>
                    <el-image 
                        style="width: 100px; height: 100px;"
                        fit="contain"
                        z-index="2"
                        initial-index="2"
                        :src="userData.note2_url" 
                        :preview-src-list="shareUrl">
                    </el-image>
                    <el-image 
                        style="width: 100px; height: 100px;"
                        fit="contain"
                        z-index="3"
                        initial-index="3"
                        :src="userData.note3_url" 
                        :preview-src-list="shareUrl">
                    </el-image>
                </el-form-item>
                <el-form-item label="审核状态" prop="">
                    <el-radio v-model="shareSatus" :disabled="shareIsFinish" :label="3">不通过</el-radio>
                    <el-radio v-model="shareSatus" :disabled="shareIsFinish" :label="1">通过</el-radio>
                </el-form-item>
                <el-form-item label="审核不通过原因" prop="phone">
                    <el-input v-model="userData.remark"></el-input>
                </el-form-item>
                <el-form-item label="是否发放" prop="">
                    <el-switch
                        :disabled="shareSatus != 1"
                        v-model="shareIsFinish"
                        active-color="#13ce66"
                        inactive-color="#c0c4cc">
                    </el-switch>
                </el-form-item>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="updateConfirm">
                            <span>提交</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default({
    name: 'renew-review',
    data() {
        return {
            oldSatus: 0,
            oldIsFinish: false,
            shareSatus: 0,
            shareIsFinish: false,
            shareUrl: [],
            userData: {}
        }
    },
    watch: {
    },
    activated() {
        this.userData.id = this.$route.query.id;
        if(!this.userData.id){
            this.$router.go(-1);
            return;
        }
        this.getList();
    },
    methods: {
        getList() {
            this.api.getRenewList({id: this.userData.id}).then(data => {
                this.userData = data.data.list[0];
                if(this.userData.old_status == 2) {  //以旧换新已发放
                    this.oldIsFinish = true;
                    this.oldSatus = 1;
                }else if(this.userData.old_status == 1){  //审核通过，待发放
                    this.oldSatus = 1;
                }else if(this.userData.old_status == 3){  //审核不通过
                    this.oldSatus = 3;
                }else{
                    this.oldSatus = 0;
                }
                if(this.userData.cash_status == 2) {  //分享返现已发放
                    this.shareIsFinish = true;
                    this.shareSatus = 1;
                }else if(this.userData.cash_status == 1){  //审核通过，待发放
                    this.shareSatus = 1;
                }else if(this.userData.cash_status == 3){  //审核不通过
                    this.shareSatus = 3;
                }else{
                    this.shareSatus = 0;
                }
                if(this.userData.note1_url) {
                    this.shareUrl = [this.userData.note1_url, this.userData.note2_url, this.userData.note3_url];
                }
            })
        },
        updateConfirm() {
            if(this.oldIsFinish) {
                this.userData.old_status = 2;
            }else{
                this.userData.old_status = this.oldSatus;
            }
            if(this.shareIsFinish) {
                this.userData.cash_status = 2;
            }else{
                this.userData.cash_status = this.shareSatus;
            }
            this.api.updateRenewOrder(this.userData).then(data => {
                if(data.code == 0 || data.code == 200) {
                    this.$message.success('操作成功！');
                }
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .el-form{
        max-width: 500px;
    }
</style>



// WEBPACK FOOTER //
// src/view/product/renew/review.vue